import { Link } from "react-router-dom";
import breadLogo from "../images/bread_logo_192.png";
import { buildClasses } from "../utils/buildClasses";

export function BreadLogo() {
  return (
    <Link to="/" aria-label="Go to your configured home page">
      <img
        src={breadLogo}
        className={buildClasses("w-7", "cursor-pointer")}
        alt="Bread logo"
      />
    </Link>
  );
}
